export const streamKind = {
  type: "string",
  enum: ["audio", "video"]
};
